import { IProps } from "./types";
import { fetchAllChannels, fetchCompanyUsers, formatDateTime, formatDateTime2, getChannelDetails, truncateText } from "../../lib/messageUtils";
import { useEffect, useState } from "react";
import { logError } from '../../lib/rumLogger';

const ChatInformation = (props: IProps) => {
const { sender, job, channel, companyUsers, receiver, onDismiss } = props
const [existingChannel, setExistingChannel] = useState<any | null>(null)
const [dateTime, setDateTime] = useState<string | null>(null)

  useEffect(() => {
    if(receiver.userArn) {
      const size = 1000
      const from = 0
      let channels: any[] = []

      fetchAllChannels(channels, receiver.userArn, size, from, "").then((res) => {
        const matchedChannel = res.find((item: any) => {
          const metadata = item?.ChannelSummary?.Metadata
          if (!metadata) return false
            try {
              const parsedMetadata = JSON.parse(metadata)
              const members = parsedMetadata?.Members || []
              const jobId = parsedMetadata?.JobId

              if (companyUsers) {
                return companyUsers.some(userId => {
                  const memberString = `${userId}-Recruiter`
                  return (
                    userId !== Number(sender.external_user_id)
                    && members.includes(memberString)
                    && jobId === job?.job_id
                  );
                });
              }
              return false;
            } catch (err) {
              logError(err as Error, 'fetchAllChannels', { receiverUserArn: receiver.userArn, jobId: job?.job_id })
               return false
            }
          });

          if (matchedChannel) {
            getChannelDetails(matchedChannel?.ChannelSummary?.ChannelArn, sender.userArn).then(async (res) => {
            setExistingChannel(res?.Channel || null)
            await setDateTime(formatDateTime2(res?.Channel?.CreatedTimestamp))
          });
        }
      });
    }
  }, [receiver.userArn, channel?.channelArn, companyUsers, sender, job])

  if (!existingChannel || !dateTime) return null

  return (
    <div style={{
      backgroundColor: '#f0f4ff',
      padding: '10px 36px 10px 10px',
      borderRadius: '6px',
      margin: '10px',
      position: 'relative',
      fontSize: '14px',
      color: '#333'
    }}>
      A chat with <strong>{receiver.first_name} {receiver.last_name}</strong> was opened by <strong>{existingChannel?.CreatedBy?.Name}</strong> on <strong>{dateTime}</strong> about Job ID <strong>{job.job_id}</strong>.
      <button
        onClick={onDismiss}
        style={{
          position: 'absolute',
          top: '8px',
          right: '10px',
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          fontSize: '16px',
          lineHeight: '1',
          color: '#666'
        }}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  )
}

export default ChatInformation
